import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { UserActivityService } from '../services';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

export const httpRequestUserActivityInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const userActivityService = inject(UserActivityService);  
  userActivityService.notifyActivity();
  return next(req);
};